module.exports = __webpack_public_path__ + "static/03-0d7740349a32feed729944ac8a32cfc5.png";